export enum Method {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum Mode {
  CORS = 'cors',
  NOCORS = 'no-cors',
  SAMEORIGIN = 'same-origin',
}

export enum ContentType {
  JSON = 'application/json',
}
